var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useMemo } from 'react';
import { EyeTableIcon } from '@/presentation/components/icons';
import { dateFormat } from '@/presentation/utils/parse-date';
import { useRecoilState } from 'recoil';
import { manageClassesState } from '../components/atoms';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { TableItemNumber } from '@/presentation/components';
import { useNavigate } from 'react-router';
import { mapToCardinal, toCardinal } from '@/presentation/functions/cardinal';
const UseManageClasses = (loadClassesPaginated, loadUsers, Styles) => {
    const [state, setState] = useRecoilState(manageClassesState);
    const { getIdClient } = useUserSesssion();
    const navigate = useNavigate();
    useEffect(() => {
        getClassesPaginated(state.filters);
    }, [state.filters.input, state.filters.selectedGradeId, state.reloadClasses]);
    useEffect(() => {
        getGradesListData();
        getTeachers();
        getClassesPaginated(state.filters);
    }, []);
    const getClassesPaginated = (filters, pagination = {
        pageIndex: 1,
        pageSize: 10
    }, sort) => __awaiter(void 0, void 0, void 0, function* () {
        changeLoading(true);
        console.log('FILTER FIRST', filters);
        const clientId = getIdClient();
        const filterProps = {
            clientsIds: [clientId.toString()],
            selectedGradeId: filters.selectedGradeId,
            input: filters.input
        };
        const classes = yield loadClassesPaginated.getClassesPaginated(filterProps, sort, pagination);
        changeLoading(false);
        if (classes && classes.total > 0 && classes.data.length > 0) {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { classes: {
                        data: classes.data,
                        count: classes.count,
                        total: classes.total,
                        page: classes.page,
                        pageCount: classes.pageCount
                    }, dataNotFound: false });
            });
        }
        else {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { classes: {
                        data: [],
                        count: 0,
                        total: 0,
                        page: 0,
                        pageCount: 0
                    }, dataNotFound: true });
            });
        }
    });
    const getTeachers = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isLoading: true });
        });
        const clientId = getIdClient();
        const TEACHER_ROLE = '10';
        const filterProps = {
            clientsIds: [clientId.toString()],
            rolesIds: [TEACHER_ROLE]
        };
        const teachers = yield loadUsers.getUsers(filterProps);
        if (teachers && teachers.length > 0) {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { teachers: teachers });
            });
        }
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isLoading: false });
        });
    });
    const changeLoading = (value) => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isTableLoading: value });
        });
    };
    const getGradesListData = () => {
        const grades = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        if (grades) {
            const classesData = grades === null || grades === void 0 ? void 0 : grades.map(element => {
                return {
                    key: `${element}`,
                    value: toCardinal(element)
                };
            });
            classesData.unshift({ key: '0', value: 'All Grades' });
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { grades: classesData });
            });
        }
    };
    const columnAlternativeNames = {
        createdAt: 'Date',
        name: 'Class Name',
        teachers: 'Assigned Teachers',
        grades: 'Grades',
        studentsAmount: 'Students',
        view: 'View'
    };
    const columnsWithoutSort = ['view'];
    const setColumnsByModel = () => {
        const keys = ['createdAt', 'name', 'teachers', 'grades', 'studentsAmount'];
        const columns = keys.map(key => {
            return Object.assign({ accessorFn: row => row[key], id: key, cell: info => info.getValue(), header: () => React.createElement("span", null, columnAlternativeNames[key]), enableSorting: key !== 'studentsAmount' }, getColumnSize(key));
        });
        columns.push(Object.assign({ accessorFn: row => row.view, id: 'view', cell: info => info.getValue(), header: () => React.createElement("span", null, columnAlternativeNames.view), enableSorting: false, sortingFn: () => 0 }, sizeProps(5)));
        return columns;
    };
    const sizeProps = (size) => ({ size, maxSize: size, minSize: size });
    const getColumnSize = (key) => {
        switch (key) {
            case 'createdAt':
                return sizeProps(15);
            case 'name':
                return sizeProps(20);
            case 'teachers':
                return sizeProps(20);
            case 'grades':
                return sizeProps(10);
            case 'studentsAmount':
                return sizeProps(10);
            default:
                return sizeProps(10);
        }
    };
    const columns = useMemo(() => [...setColumnsByModel()], []);
    const mapTeachers = (teachers) => {
        const response = teachers.map((teacher, index) => {
            return (React.createElement("div", { key: index, className: Styles.blue }, teacher === null || teacher === void 0 ? void 0 :
                teacher.title,
                " ",
                teacher.firstName,
                " ",
                teacher.lastName));
        });
        return response;
    };
    const renderCellByType = (context, row) => {
        var _a;
        const { column } = context;
        switch (column.id) {
            case 'createdAt':
                return React.createElement("div", null, dateFormat(row === null || row === void 0 ? void 0 : row.createdAt));
            case 'name':
                return React.createElement("span", null, row === null || row === void 0 ? void 0 : row.name);
            case 'teachers':
                return React.createElement("span", null, mapTeachers(row === null || row === void 0 ? void 0 : row.teachers));
            case 'grades':
                return React.createElement("span", null, (_a = mapToCardinal(row === null || row === void 0 ? void 0 : row.grades)) === null || _a === void 0 ? void 0 : _a.join(', '));
            case 'studentsAmount':
                return React.createElement(TableItemNumber, { text: row === null || row === void 0 ? void 0 : row.studentsAmount.toString() });
            case 'view':
                return (React.createElement("div", { className: Styles.actionWrap },
                    React.createElement(EyeTableIcon, { onClick: () => navigate(`/school-dashboard/manage-classes/${row.id}`) })));
            default:
                return React.createElement("span", null);
        }
    };
    return {
        columns,
        columnsWithoutSort,
        getClassesPaginated,
        renderCellByType
    };
};
export default UseManageClasses;
